import ConfirmReceptModal from './confirm-recept-modal.vue'
export default ConfirmReceptModal
